import { useCallback } from "react"
import { Box, Typography, TextField, InputAdornment } from "@mui/material"
import { InfoOutlined } from "@mui/icons-material"
import { CONSTRAINTS } from "modules/optimization-settings/selectors/constraints"
import OPTooltip from "components/material/tooltip"
import { RulesSection } from "connected-components/optimize-experiments/configuration-sections"

import "./style.scss"

interface RulesProps {
  rules: RulesSection
  onRulesChange: (rules: RulesSection) => void
}

export default function Rules({ rules, onRulesChange }: RulesProps) {
  const maxTurnover = CONSTRAINTS.maxTurnover()
  const tooltip = maxTurnover.tooltip
  const error = maxTurnover.validation(rules.maxTurnover)

  const handleFieldChange = useCallback(<K extends keyof RulesSection>(field: K, value: RulesSection[K]) => {
    const newRules: RulesSection = {
      ...rules,
      [field]: value,
    }
    onRulesChange(newRules)
  }, [rules, onRulesChange])

  return (
    <Box className="components_rules">
      <Typography color="inherit" noWrap className="rules-label">
        Rules
      </Typography>

      <Box className="rules-content">
        <Box className="rules-constraints">
          <Box display="flex" alignItems="center" gap={1}>
            <Typography color="inherit" noWrap>
              Max turnover:
            </Typography>
            <TextField
              id="constraint-max-turnover"
              variant="standard"
              type="number"
              value={rules.maxTurnover}
              onChange={(event) => handleFieldChange("maxTurnover", event.target.value)}
              error={!!error}
              helperText={error}
              slotProps={{
              input: {
                startAdornment: <InputAdornment style={{ whiteSpace: "nowrap" }} position="start">%</InputAdornment>,
                endAdornment: <InputAdornment style={{ whiteSpace: "nowrap" }} position="end"><OPTooltip title={tooltip}><InfoOutlined /></OPTooltip></InputAdornment>,
              },
              htmlInput: {
                min: maxTurnover.min,
              },
            }}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
